import { toMs } from "@/utils/date.util";

// Foreground and background inactivity timeout
const DefaultUserInactivityTimeoutMs = toMs({ minutes: 7 });
const VideoActivityHeartbeatIntervalMs = toMs({ minutes: 1 });

// Helper function to determine if the app was inactive
const wasInactive = (state: string) => {
  // eslint-disable-next-line sonarjs/prefer-regexp-exec -- currently reported in SonarQube as unresolved
  return state.match(/inactive|background/) !== null;
};

// Helper function to determine if the app is foregrounding based on the current and next state
const isForegrounding = ({
  currentState,
  nextState,
}: {
  currentState: string;
  nextState: string;
}) => wasInactive(currentState) && nextState === "active";

// Helper function to determine if the app is backgrounding based on the current and next state
const isBackgrounding = ({
  currentState,
  nextState,
}: {
  currentState: string;
  nextState: string;
}) => {
  return currentState === "active" && nextState !== "active";
};
export {
  DefaultUserInactivityTimeoutMs,
  isBackgrounding,
  isForegrounding,
  VideoActivityHeartbeatIntervalMs,
};
